import { Pipe, PipeTransform, inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

/**
 * region pipe transforms a region code, like `de`,
 * into a translated representation of display name
 * based on user language, e.g. `Deutschland`
 * @class RegionNamePipe
 * @typedef {RegionNamePipe}
 * @implements {PipeTransform}
 */
@Pipe( {
    name: 'regionName',
    standalone: true
} )
export class RegionNamePipe implements PipeTransform {
    #cookieService = inject( CookieService );

    currentLanguage = this.#cookieService.get( 'language' ) || document.documentElement.lang;

    /**
     * transforms country code into country displayname
     * @param {string | undefined} code language code
     * @returns {string} translated region / country displayname
     */
    transform( code: string | undefined ): string {
        let region = '';
        if ( code ) {
            const regionName = new Intl.DisplayNames( [this.currentLanguage], { type: 'region' } ).of( code );
            region += regionName;
        }
        return region;
    }
}
